var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnmuted = function SvgUnmuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.84 1.078a.755.755 0 00-.785.072L4.252 5.502H.75a.75.75 0 00-.75.75v6.003c0 .415.335.75.75.75h3.502l5.803 4.352a.747.747 0 00.785.071.751.751 0 00.415-.671V1.75a.751.751 0 00-.415-.672zM13.689 6.07l-.53-.53-1.062 1.06.53.531a3.003 3.003 0 010 4.244l-.53.53 1.061 1.062.53-.53a4.507 4.507 0 000-6.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.28 3.417l-1.06 1.061.53.53a6.01 6.01 0 010 8.49l-.53.53 1.06 1.061.53-.53c2.926-2.926 2.926-7.686 0-10.612l-.53-.53z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgUnmuted;